function setTwoDigits(num) {
    return num.toString().padStart(2, '0');
}

export default function formatDate(str) {
    const date = new Date(str);
    return `${setTwoDigits(date.getDate())}/${setTwoDigits(date.getMonth() + 1)}/${date.getFullYear()}`
}